import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import StudentsList from "./StudentsList";

const StudentsListWrapper = () => {

    const { userCan, isFacilitatorManager } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Gestión de clientes' },
        { name: 'Empleados', href: menuRoutes.students.path },
    ];

    const defaultFilters = {
        active: true,
    };

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Listado de empleados" breadcrumb={breadCrumb}>
                    {
                        !isFacilitatorManager &&
                        userCan('create_students', 'students') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { navigate(menuRoutes.students.create) }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear empleado
                            </Button>
                        )
                    }

                </PageHeader>
                <StudentsList />
            </FiltersProvider>
        </Fragment>
    );
}

export default StudentsListWrapper;
